import { Project } from "@customink/signalmizely-core";
import { LogLevel } from "@optimizely/optimizely-sdk";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
const SIGNALMIZELY_FORCED_COOKIE_PREFIX = "sm_f_";
const OPTIMIZELY_USER_ID_COOKIE = "optimizelyEndUserId";
const DEFAULT_CONFIG = {
    autoUpdate: true,
    updateInterval: 300000, // 5 minutes in milliseconds
    logLevel: LogLevel.ERROR,
};
export class Helpers {
    projectPromise = null;
    config;
    constructor(config) {
        this.config = { ...DEFAULT_CONFIG, ...config };
    }
    async getProject() {
        if (!this.projectPromise) {
            this.projectPromise = Project.initialize({
                sdkKey: this.config.sdkKey,
                options: {
                    autoUpdate: this.config.autoUpdate,
                    updateInterval: this.config.updateInterval,
                    logLevel: this.config.logLevel,
                },
            });
        }
        return await this.projectPromise;
    }
    async flagDecision(flagKey, options = {}) {
        const signalmizelyProject = await this.getProject();
        const resolvedUserId = options.userId || getSignalmizelyUserId();
        const variationOverride = getSignalmizelyVariationOverride(flagKey);
        const decision = await signalmizelyProject.decision(flagKey, resolvedUserId, variationOverride);
        return decision;
    }
    async flagVariation(flagKey, options = {}) {
        const decision = await this.flagDecision(flagKey, options);
        return decision.variationKey;
    }
    async close() {
        if (this.projectPromise) {
            const project = await this.projectPromise;
            await project.close();
            this.projectPromise = null;
        }
    }
}
function getEffectiveCookieDomain() {
    const hostname = window.location.hostname;
    const hostArray = hostname.split(".");
    if (hostArray.includes("localhost")) {
        return undefined;
    }
    else if (/\d$/.test(hostArray[hostArray.length - 1])) {
        return hostname;
    }
    else {
        const domain = "." +
            (hostArray.length > 1 ? hostArray.slice(-2).join(".") : hostArray[0]);
        return domain;
    }
}
function getSignalmizelyUserId() {
    let userId = Cookies.get(OPTIMIZELY_USER_ID_COOKIE);
    if (!userId) {
        userId = uuidv4();
        const expiresDays = 6 * 30; // 6 months in days (approx)
        const cookieOptions = {
            expires: expiresDays,
            path: "/",
        };
        const effectiveDomain = getEffectiveCookieDomain();
        if (effectiveDomain) {
            cookieOptions.domain = effectiveDomain;
        }
        Cookies.set(OPTIMIZELY_USER_ID_COOKIE, userId, cookieOptions);
    }
    return userId;
}
function getSignalmizelyVariationOverride(key) {
    return Cookies.get(`${SIGNALMIZELY_FORCED_COOKIE_PREFIX}${key}`) || undefined;
}
